import { HttpErrorResponse } from '@angular/common/http';
import { createAction, props } from '@ngrx/store';
import { Billers } from './state';

/**
 * Load biller beneficiaries
 */
export const loadBillerBeneficiaries = createAction(
  '[Biller Beneficiaries] Load Biller Beneficiaries'
);

export const loadBillerBeneficiariesSuccess = createAction(
  '[Biller Beneficiaries] Load Biller Beneficiaries Success',
  props<{ billerBeneficiaries: any[] }>()
);

export const loadBillerBeneficiariesFailure = createAction(
  '[Biller Beneficiaries] Load Biller Beneficiaries Failure',
  props<{ error: HttpErrorResponse }>(),
);

/**
 * Load billers
 */
export const loadBillers = createAction(
  '[Billers] Load Billers '
);

export const loadBillersSuccess = createAction(
  '[Billers] Load Billers Success',
  props<{ billers: Billers[] }>()
);

export const loadBillersFailure = createAction(
  '[Billers] Load Billers Failure',
  props<{ error: HttpErrorResponse }>(),
);

/**
 * Get pending bills
 */

export const loadPendingBills = createAction(
  '[Pending Bills] Load Pending Bills ',
  props<{ payload: any }>()
);

export const loadPendingBillsSuccess = createAction(
  '[Pending Bills] Load Pending Bills Success',
  props<{ pendingBills: any, responseMessage: string }>()
);

export const loadPendingBillsFailure = createAction(
  '[Pending Bills] Load Pending Bills Failure',
  props<{ error: HttpErrorResponse }>(),
);

/**
 * Update biller
 */

export const updateBiller = createAction(
  '[Billers] Update Biller ',
  props<{ billerId: string, payload: any }>()
);

export const updateBillerSuccess = createAction(
  '[Billers] Update Biller Success',
  props<{ updatedBillerDetails: any }>()
);

export const updateBillerFailure = createAction(
  '[Billers] Update Biller Failure',
  props<{ error: HttpErrorResponse }>(),
);

/**
 * Delete biller
 */

export const deleteBiller = createAction(
  '[Billers] Delete Biller ',
  props<{ billerId: string }>()
);

export const deleteBillerSuccess = createAction(
  '[Billers] Delete Biller Success'
);

export const deleteBillerFailure = createAction(
  '[Billers] Delete Biller Failure',
  props<{ error: HttpErrorResponse }>(),
);